import { APIAttachment, APIDocumentArchiveFolder } from '@ardoq/api-types';
import { DocumentArchiveContext } from '@ardoq/api-types';
import { AttachmentWithContext, FolderWithContext } from './types';

// Fix data corruption where folder._id === folder.parent (ARD-14194)
const removeSelfReferentialParent = (
  folder: FolderWithContext
): FolderWithContext => {
  if (folder._id !== folder.parent) {
    return folder;
  }

  return { ...folder, parent: null };
};

const addContextToFolder = (
  folder: APIDocumentArchiveFolder
): FolderWithContext => ({ ...folder, context: toFolderContext(folder) });

export const toFolderContext = (folder: APIDocumentArchiveFolder) =>
  folder.resource.type === 'org'
    ? DocumentArchiveContext.ORG
    : DocumentArchiveContext.WS;

// If rootWorkspace exists, it's workspace-specific; otherwise it's org-level
export const toAttachmentContext = (attachment: APIAttachment) =>
  attachment.rootWorkspace
    ? DocumentArchiveContext.WS
    : DocumentArchiveContext.ORG;

// Derive context from rootWorkspace field for attachments
const addContextToAttachment = (
  attachment: APIAttachment
): AttachmentWithContext => ({
  ...attachment,
  context: toAttachmentContext(attachment),
});

export const fixDataOperations = {
  removeSelfReferentialParent,
  addContextToFolder,
  addContextToAttachment,
};
